import { Table } from "@mantine/core";
import dayjs from "dayjs";
import { useCallback, useMemo } from "react";
import { useParams } from "react-router-dom";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { useGetApi } from "src/hooks";
import {
  LayoutContainer,
  PageContainer,
  StyledTd,
  StyledTh,
  StyledTr,
} from "src/styled";

import { type IUserHistoryItem } from "./UserHistory.types";

const mapUserHistory = (data: any) => {
  return (data.list ?? data.data) as IUserHistoryItem[];
};

interface Props {
  requestUrl: string;
}

const UserHistory = ({ requestUrl }: Props) => {
  const { userId: userid, genid } = useParams();

  const { data } = useGetApi({
    request: requestUrl,
    body: { params: { ...(userid && { userid }), ...(genid && { genid }) } },
    mapper: mapUserHistory,
  });

  const shouldUseAction = useMemo(() => genid, [genid]);

  const renderDescription = useCallback(
    (row: IUserHistoryItem) => {
      if (shouldUseAction) {
        return row.action;
      }
      if (row.diff?.length > 0) {
        return row.diff.map(d => (
          <p style={{ margin: 0 }} key={d}>
            {d}
          </p>
        ));
      } else {
        let action = "";
        switch (row.action) {
          case "editUser":
            action = "Details Changed";
            break;
          case "GDPR":
            action = "GDPR Accepted";
            break;
          default:
            action = "Details Changed";
        }
        return <p style={{ margin: 0 }}>{action}</p>;
      }
    },
    [shouldUseAction],
  );

  return (
    <PageContainer>
      <Breadcrumbs />
      <LayoutContainer>
        <Table>
          <thead>
            <StyledTr>
              <StyledTh style={{ width: "50%" }}>
                {shouldUseAction ? "Action" : "Difference"}
              </StyledTh>
              <StyledTh style={{ width: "30%" }}>Author</StyledTh>
              <StyledTh style={{ width: "20%" }}>Date</StyledTh>
            </StyledTr>
          </thead>
          <tbody>
            {data?.map(item => (
              <StyledTr key={item.hid}>
                <StyledTd>{renderDescription(item)}</StyledTd>
                <StyledTd>{`${item.rolename} - ${item.full_name}`}</StyledTd>
                <StyledTd>
                  {dayjs(item.timestamp).format("D MMM YYYY - HH:mm")}
                </StyledTd>
              </StyledTr>
            ))}
          </tbody>
        </Table>
      </LayoutContainer>
    </PageContainer>
  );
};

export default UserHistory;
